<template>
  <v-col :cols="cols">
    <v-row>
      <v-col cols="auto" class="px-1" v-if="left">
        <h4 class="my-1">
          <v-icon v-if="icon">mdi-{{ icon }}</v-icon> {{ text }}
        </h4>
      </v-col>
      <v-col cols="auto" class="px-0">
        <Tooltip :content="tooltip" top>
          <v-switch class="my-0" :color="color" v-model="knob"> </v-switch>
        </Tooltip>
      </v-col>
      <v-col cols="auto" class="px-1" v-if="!left">
        <h4 class="my-1">
          <v-icon v-if="icon">mdi-{{ icon }}</v-icon> {{ text }}
        </h4>
      </v-col>
    </v-row>
  </v-col>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";
import Tooltip from "@/components/Tooltip.vue";

export default Vue.extend({
  name: "KnobBtnComp",

  data() {
    return {};
  },
  props: {
    value: VueTypes.any,
    left: VueTypes.bool.def(true),
    disabled: VueTypes.bool.def(false),
    icon: VueTypes.string.def(""),
    text: VueTypes.string.def(""),
    cols: VueTypes.string.def("auto"),
    color: VueTypes.string.def("success"),
    tooltip: VueTypes.string,
  },
  computed: {
    knob: {
      get() {
        return this.value;
      },
      set(val: boolean) {
        this.$emit("input", val);
      },
    },
  },
  components: { Tooltip },
});
</script>
